import React, { useState } from 'react';
import { InfoBox, InputGroup } from '../Common';

const fmtCur = new Intl.NumberFormat('en-IN', { maximumFractionDigits: 2 });
const fmtNoDec = new Intl.NumberFormat('en-IN', { maximumFractionDigits: 0 });

const PlanTool = () => {
    const [cap, setCap] = useState(1000000);
    const [tgt, setTgt] = useState(20);
    const [ls, setLs] = useState(65);
    const [lots, setLots] = useState(4);
    const [td, setTd] = useState(250);

    const annualProfit = (cap * tgt) / 100;
    const vpp = lots * ls;                          
    const ptsYear = vpp > 0 ? annualProfit / vpp : 0;
    const ptsDay = td > 0 ? ptsYear / td : 0;

    return (
        <div className="tct-tool-container">
            <div className="tct-panel-title">Return Planning Calculator</div>

            <div className="tct-input-wrap d-flex flex-wrap gap-2">
                <InputGroup label="Capital" value={cap} onChange={setCap} />
                <InputGroup label="Target Return %" value={tgt} onChange={setTgt} />
                <InputGroup label="Lot Size" value={ls} onChange={setLs} />
                <InputGroup label="Lots" value={lots} onChange={setLots} />
                <InputGroup label="Trading Days" value={td} onChange={setTd} />
            </div>

            <div className="tct-results-grid mt-4">
                <div className="tct-card">
                    <div className="tct-data-row">
                        <span className="tct-label">Annual Profit Goal</span>
                        <span className="tct-value val-green">₹{fmtCur.format(annualProfit)}</span>
                    </div>
                    <div className="tct-data-row">
                        <span className="tct-label">Points Needed (Yearly)</span>
                        <span className="tct-value big-value val-blue">{fmtNoDec.format(ptsYear)} pts</span>
                    </div>
                    <div className="tct-data-row" style={{ borderBottom: 'none' }}>
                        <span className="tct-label">Points Needed (Daily)</span>
                        <span className="tct-value big-value val-amber">{ptsDay.toFixed(1)} pts</span>
                    </div>
                </div>
            </div>

            <InfoBox
                title="Trading Return Planning: How Many Points You Need to Achieve Your Goals"
                meta="Learn how to translate yearly trading goals into daily profit targets."
                sections={[
                    {
                        title: 'Introduction',
                        content: 'Many traders set return goals but never calculate what those goals require.<br><br>Return planning connects:<br>• capital<br>• strategy<br>• market movement.',
                    },
                    {
                        title: 'Example',
                        content: 'Capital = 10L<br>Target return = 20%<br><br>Required daily profit might be only 3 points per day.',
                    },
                ]}
            />
        </div>
    );
};

export default PlanTool;